export default "__VITE_ASSET__7b544526__"